import React from "react";
import {useFormContext} from "react-hook-form";
import {PresenzeGiornataPlusRecord} from "@commons/mapping/PresenzeGiornataPlusRecord";
import {IconCheck, IconLock, IconLockOpen2, IconRecycle, IconSettings} from "@tabler/icons-react";
import TooltipEx from "@components/Tooltip";

interface PulsantieraGiornataPlusSTDProps {
    // giornataBloccata: boolean
    /*
        setDayModified: (day2Update: PresenzeGiornataPlusRecord, modified: boolean) => void,
        day: PresenzeGiornataPlusRecord,
    */
    disabled?: boolean,
    dismissModal: () => void,
    calcola?: () => void,
    compensa?: () => void,
}

const PulsantieraGiornataPlusSTD: React.FC<PulsantieraGiornataPlusSTDProps> = ({
                                                                                   disabled = false,
                                                                                   dismissModal,
                                                                                   calcola = () => {
                                                                                   },
                                                                                   compensa = () => {
                                                                                   }
                                                                               }) => {
    const {setValue, watch} = useFormContext<PresenzeGiornataPlusRecord>();
    const giornataBloccata = watch('giornataBloccata');
    const arrotondateLocked = watch('arrotondateLocked');

    const tooltipCss = 'w-fit max-w-80 bg-gray-700 z-50 text-white p-2 rounded text-[13px]';

    return <>
        <div className="flex items-center mr-auto space-x-2">
            <TooltipEx tooltip={arrotondateLocked ? 'F2 - Calcola a partire dalle arrotondate' : 'F2 - Calcola a partire dalle effettive'} className={tooltipCss}>
                <button type="button" className="btnDefault bg-white p-1.5 sm:p-2" disabled={disabled} onClick={() => calcola()}>
                    <IconSettings className="size-4 sm:size-5" strokeWidth={1.5}/>&nbsp;Calcola
                </button>
            </TooltipEx>
            <TooltipEx tooltip="F8 - Calcola a partire dalle arrotondate compensando le ore mancanti con quelle eccedenti" className={tooltipCss}>
                <button type="button" className="btnDefault bg-white p-1.5 sm:p-2" disabled={disabled} onClick={() => compensa()}>
                    <IconRecycle size={19} strokeWidth={1.5}/>&nbsp;Compensa
                </button>
            </TooltipEx>
            <button type="button" className="btnDefault bg-white p-1.5 sm:p-2" disabled={disabled || !giornataBloccata} onClick={() => {
                setValue('giornataBloccata', false, {shouldDirty: true});
            }}>
                {giornataBloccata && <IconLock className="size-5" strokeWidth={1.5}/>}
                {!giornataBloccata && <IconLockOpen2 className="size-5" strokeWidth={1.5}/>}
            </button>
        </div>
        <div className="flex items-center ml-auto space-x-2">
            <TooltipEx tooltip="Consolida le modifiche e chiude il pannello di gestione" className={tooltipCss}>
                <button type="submit" className="btnPrimary p-1.5 sm:p-2 ml-auto" disabled={disabled}>
                    <IconCheck className="size-4 sm:size-5"/>&nbsp;Consolida
                </button>
            </TooltipEx>
            <TooltipEx tooltip="Annulla le modifiche e chiude il pannello di gestione" className={tooltipCss}>
                <button type="button" className="btnPrimary p-1.5 sm:p-2" onClick={() => dismissModal()}>Annulla</button>
            </TooltipEx>
        </div>
    </>
}

export default PulsantieraGiornataPlusSTD;